import React, { useState } from "react";
import { Button } from "react-bootstrap";
import {
  FiEdit,
  FiInbox,
  FiStar,
  FiSend,
  FiFileText,
  FiTrash2,
  FiAlertCircle,
  FiChevronDown,
  FiChevronUp
} from "react-icons/fi";

import {
  AiOutlineFolder,
} from "react-icons/ai";

import {
  BsSquare
} from "react-icons/bs";
import { FaFolder } from "react-icons/fa";

const EmailSidebar = ({ openCompose }) => {

  const [showEmails, setShowEmails] = useState(false);
  const [showLabels, setShowLabels] = useState(false);
  const [showFolders, setShowFolders] = useState(false);

  return (
    <div className="hide-scrollbar"
      style={{
        width: "300px",
        borderRight: "1px solid #eee",
        background: "#f8f9fa",
        height: "100vh",
        padding: "15px",
        overflowY: "auto"
      }}
    >

      {/* Profile */}
      <div
        style={{
          boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
          padding: "10px",
          borderRadius: "8px",
          marginBottom: "20px"
        }}
      >
        <div className="d-flex align-items-center">
          <img
            src="/assets/img/profiles/avatar-02-1.jpg"
            alt=""
            style={{
              width: "45px",
              height: "45px",
              borderRadius: "50%",
              marginRight: "10px"
            }}
          />
          <div>
            <h6 className="mb-0">James Hong</h6>
            <small>[email protected]</small>
          </div>
        </div>
      </div>

      {/* Compose */}
      <Button
        onClick={openCompose}
        style={{
          background: "#ff6b1a",
          border: "none",
          width: "100%",
          marginBottom: "25px"
        }}
      >
        <FiEdit className="me-2" />
        Compose
      </Button>

      {/* EMAILS */}
      <h6 className="fw-bold">Emails</h6>

      <div className="mt-3">

        <div className="d-flex justify-content-between p-2 bg-light rounded mb-2">
          <span><FiInbox className="me-2"/>Inbox</span>
          <span className="badge bg-danger">56</span>
        </div>

        <div className="d-flex justify-content-between p-2 mb-2">
          <span><FiStar className="me-2"/>Starred</span>
          <span>46</span>
        </div>

        <div className="d-flex justify-content-between p-2 mb-2">
          <span><FiSend className="me-2"/>Sent</span>
          <span>14</span>
        </div>

        <div className="d-flex justify-content-between p-2 mb-2">
          <span><FiFileText className="me-2"/>Drafts</span>
          <span>12</span>
        </div>

        <div className="d-flex justify-content-between p-2 mb-2">
          <span><FiTrash2 className="me-2"/>Deleted</span>
          <span>08</span>
        </div>

        <div className="d-flex justify-content-between p-2 mb-2">
          <span><FiAlertCircle className="me-2"/>Spam</span>
          <span>0</span>
        </div>

        {showEmails && (
          <>
            <div className="d-flex justify-content-between p-2 mb-2">
              <span>📌 Important</span>
              <span>12</span>
            </div>

            <div className="d-flex justify-content-between p-2 mb-2">
              <span>📧 All Emails</span>
              <span>34</span>
            </div>
          </>
        )}

        <div
          style={{ cursor: "pointer", fontSize: "14px" }}
          onClick={() => setShowEmails(!showEmails)}
        >
          {showEmails ? (
            <span>Less <FiChevronUp/></span>
          ) : (
            <span>Show More <FiChevronDown/></span>
          )}
        </div>

      </div>

      <hr/>

      {/* LABELS */}
      <div className="d-flex justify-content-between align-items-center">
        <h6 className="fw-bold">Labels</h6>
        <span style={{cursor:"pointer",color:"#ff6b1a"}}>+</span>
      </div>

      <div>

        <p className="mb-2">
          <BsSquare className="text-success me-2"/> Team Events
        </p>

        <p className="mb-2">
          <BsSquare className="text-warning me-2"/> Work
        </p>

        <p className="mb-2">
          <BsSquare className="text-danger me-2"/> External
        </p>

        <p className="mb-2">
          <BsSquare className="text-info me-2"/> Projects
        </p>

        {showLabels && (
          <>
            <p className="mb-2">
              <BsSquare className="text-primary me-2"/> Applications
            </p>

            <p className="mb-2">
              <BsSquare className="text-secondary me-2"/> Design
            </p>
          </>
        )}

        <div
          style={{cursor:"pointer"}}
          onClick={() => setShowLabels(!showLabels)}
        >
          Show More <FiChevronDown/>
        </div>

      </div>

      <hr/>

      {/* FOLDERS */}
      <div className="d-flex justify-content-between align-items-center">
        <h6 className="fw-bold">Folders</h6>
        <span style={{cursor:"pointer",color:"#ff6b1a"}}>+</span>
      </div>

      <div>

        <p>
          <FaFolder  className="text-danger me-2"/> Projects
        </p>

        <p>
          <FaFolder  className="text-warning me-2"/> Personal
        </p>

        <p>
          <FaFolder  className="text-success me-2"/> Finance
        </p>

        {showFolders && (
          <>
            <p>
              <FaFolder  className="text-primary me-2"/> Office
            </p>

            <p>
              <FaFolder  className="text-info me-2"/> Archive
            </p>
          </>
        )}

        <div
          style={{cursor:"pointer"}}
          onClick={() => setShowFolders(!showFolders)}
        >
          Show More <FiChevronDown/>
        </div>

      </div>

      <hr/>

      {/* UPGRADE CARD */}

      <div
        style={{
          background:"#1f2933",
          borderRadius:"10px",
          padding:"20px",
          textAlign:"center",
          color:"#fff",
          marginBottom:"20px"
        }}
      >
        <div
          style={{
            width:"40px",
            height:"40px",
            borderRadius:"50%",
            background:"#fff",
            color:"#000",
            display:"flex",
            alignItems:"center",
            justifyContent:"center",
            margin:"0 auto 10px"
          }}
        >
          ⚠
        </div>

        <p style={{fontSize:"14px"}}>
          Enjoy Unlimited Access on a small price monthly.
        </p>

        <button
          style={{
            background:"#fff",
            border:"none",
            padding:"8px 14px",
            borderRadius:"6px"
          }}
        >
          Upgrade Now →
        </button>

      </div>

      {/* Footer */}

      <p style={{fontSize:"13px",color:"#777"}}>
        2014 - 2026 © SmartHR.
      </p>

    </div>
  );
};

export default EmailSidebar;